import { Project } from '../models/project.model';

export const PROJECT_ICON_MAP: Record<string, { matIcon: string; color: string }> = {
  folder: { matIcon: 'folder', color: 'var(--to-project-icon-folder)' },
  check: { matIcon: 'check_circle', color: 'var(--to-project-icon-check)' },
  chart: { matIcon: 'bar_chart', color: 'var(--to-project-icon-chart)' },
  users: { matIcon: 'group', color: 'var(--to-project-icon-users)' },
  shield: { matIcon: 'shield', color: 'var(--to-project-icon-shield)' },
  palette: { matIcon: 'palette', color: 'var(--to-project-icon-palette)' },
  settings: { matIcon: 'settings', color: 'var(--to-project-icon-settings)' },
  key: { matIcon: 'key', color: 'var(--to-project-icon-key)' },
};

export function getProjectIconDef(project: Pick<Project, 'icon'>): { matIcon: string; color: string } {
  return PROJECT_ICON_MAP[project.icon ?? 'folder'] ?? PROJECT_ICON_MAP['folder'];
}
